import { useEffect } from "react";
import { Select } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { selectNoUnits, selectUnit, selectUnits, setUnit } from "@/app/unitSlice";

/**
 * Switches the production unit every page is scoped to. Shows the full
 * site · plant · unit path, which is how planners identify a line — the
 * unit name alone is ambiguous across sites.
 */
export default function UnitSelector() {
  const dispatch = useDispatch();
  const unit = useSelector(selectUnit);
  const units = useSelector(selectUnits);
  const noUnits = useSelector(selectNoUnits);

  // A site-scoped user's stored unit may be outside their scope — snap to
  // the first unit they may actually work in.
  useEffect(() => {
    if (units.length && !units.some((u) => u.id === unit)) {
      dispatch(setUnit(units[0].id));
    }
  }, [units, unit, dispatch]);

  return (
    <Select
      value={unit ?? undefined}
      onChange={(value) => dispatch(setUnit(value))}
      loading={!units.length && !noUnits}
      placeholder={noUnits ? "No production unit yet" : undefined}
      style={{ minWidth: 330 }}
      prefix={<ApartmentOutlined style={{ color: "var(--text-muted)" }} />}
      options={units.map((u) => ({
        value: u.id,
        label: `${u.site} · ${u.plant} · ${u.name}${u.type ? ` (${u.type})` : ""}`,
      }))}
    />
  );
}
